import type { FC } from 'react';
import { Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { useRegularFcfsRoot } from 'src/apis/regular-fcfs/use-regular-fcfs-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageHeader } from 'src/components/layout/page-header';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';
import { AvailabilityCheck } from 'src/pages/transport/fcfs-booking/availability-check';
import { UnifiedFcfs } from 'src/pages/transport/fcfs-booking/unified';

export const FcfsBooking: FC = () => {
  const optionalMonolithUser = useOptionalAuthenticatedMonolithUser();
  const regularFcfsRoot = useRegularFcfsRoot();

  if (!regularFcfsRoot.loaded) return <PageSpinner />;

  const showTsoView = regularFcfsRoot.response
    ? optionalMonolithUser?.isTso &&
      regularFcfsRoot.response.data._links?.['tso-availability-check']
    : optionalMonolithUser?.isTso;

  // specific view for TSOs
  if (showTsoView) {
    return <AvailabilityCheck />;
  }

  return (
    <div
      className={`
        grid items-center gap-md
        legacy:gap-[1rem]
      `}
    >
      <PageHeader title="New Booking" />

      <Suspense fallback={<PageSpinner />}>
        <RootRoutes>
          <Route
            path="/transport/fcfs-booking"
            element={<Navigate replace to="/transport/fcfs-booking/unified" />}
          />

          <Route
            path="/transport/fcfs-booking/unified/*"
            element={<UnifiedFcfs />}
          />

          <Route
            path="/transport/fcfs-booking/regular/*"
            element={<UnifiedFcfs />}
          />

          <Route
            path="/transport/fcfs-booking/direct/*"
            element={<UnifiedFcfs />}
          />

          <Route path="*" element={<ThrowNotFound />} />
        </RootRoutes>
      </Suspense>
    </div>
  );
};
